module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/dz-2be2fee6433a59e75c3da92d5f366470.svg";